import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";

const Dashboard = () => {
  return (
    <div className="flex min-h-screen w-full bg-background">
      <Sidebar />
      <main className="ml-64 flex-1 bg-zeus min-h-screen">
        <Outlet />
      </main>
    </div>
  );
};

export default Dashboard;
